export default __webpack_public_path__ + "static/media/namria.6f3a9e2b.png";